export class SuggestionFilter {
    code?: string;
    text?: string;
}

export const allMatchingFilter: SuggestionFilter = {
    code: null,
    text: null
};

export const noMatchingFilter = {
    code: '',
    text: ''
};
